import React, { ReactElement, useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import { faLink } from '@fortawesome/free-solid-svg-icons/faLink';
import { faMinus } from '@fortawesome/free-solid-svg-icons/faMinus';
import { faPlus } from '@fortawesome/free-solid-svg-icons/faPlus';

import Button, { BUTTON_TYPES } from '@buyside/components/presentation/Button/button';
import ParsedHtml from '@buyside/components/presentation/ParsedHtml/parsedHtml';
import UserGeneratedLink from '@buyside/components/presentation/UserGeneratedLink/UserGeneratedLink';

import { Maybe, SiteMessage } from '@interfaces/graphql-typings';

import styles from './toasterStyles.scss';

const SiteMessageToaster: React.FC<{ siteMessage: SiteMessage }> = ({ siteMessage }) => {
  const textRef = useRef<Maybe<HTMLDivElement>>(null);

  const [isExpanded, setIsExpanded] = useState(false);
  const [isExpandable, setIsExpandable] = useState(false);

  const checkOverflow = (): void => {
    const element = textRef.current;

    if (element) setIsExpandable(element.scrollHeight > element.clientHeight);
  };

  useEffect(checkOverflow, [siteMessage.body]);

  return (
    <>
      <ParsedHtml html={siteMessage.body || ''}>
        {({ content }): ReactElement => (
          <div
            ref={textRef}
            className={classNames(styles.textContainer, {
              [styles.expanded]: isExpanded,
              [styles.expandable]: isExpandable
            })}
          >
            {content}
          </div>
        )}
      </ParsedHtml>
      <div className={styles.actions}>
        {isExpandable ? (
          <Button
            faIcon={isExpanded ? faMinus : faPlus}
            onClick={(): void => setIsExpanded(prev => !prev)}
            text={isExpanded ? 'Show Less' : 'Show More'}
            type={BUTTON_TYPES.LINK}
          />
        ) : null}
        {siteMessage.linkText && siteMessage.linkUrl ? (
          <UserGeneratedLink href={siteMessage.linkUrl}>
            <Button faIcon={faLink} text={siteMessage.linkText} type={BUTTON_TYPES.LINK} />
          </UserGeneratedLink>
        ) : null}
      </div>
    </>
  );
};

export default SiteMessageToaster;
